import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { FeatureFlags } from 'UI/constants/featureFlags';

export const useJobOrderProfileFeatureFlags = () => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();

  return {
    canUseUrgencyVerification: checkIfFeatureFlagEnabled(FeatureFlags.UrgencyVerification),
    isAddDailyPlanTaskEnabled: checkIfFeatureFlagEnabled(FeatureFlags.DailyPlanAddTaskFromProfile),
    isDataSheetCardsEnabled: checkIfFeatureFlagEnabled(FeatureFlags.JobOrderDataSheetFlow),
    shouldShowKeywordTags: checkIfFeatureFlagEnabled(FeatureFlags.JobOrderKeywordTags)
  };
};
